/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./email-list-index.component";
import * as i2 from "../../shared/components/breadcrumbs/breadcrumbs.service";
var styles_EmailListIndexComponent = [];
var RenderType_EmailListIndexComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_EmailListIndexComponent, data: {} });
export { RenderType_EmailListIndexComponent as RenderType_EmailListIndexComponent };
export function View_EmailListIndexComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i0.ɵted(-1, null, ["\n  email-list-index works!\n"])), (_l()(), i0.ɵted(-1, null, ["\n"]))], null, null); }
export function View_EmailListIndexComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "kkk-email-list-index", [], null, null, null, View_EmailListIndexComponent_0, RenderType_EmailListIndexComponent)), i0.ɵdid(1, 114688, null, 0, i1.EmailListIndexComponent, [i2.BreadcrumbsService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var EmailListIndexComponentNgFactory = i0.ɵccf("kkk-email-list-index", i1.EmailListIndexComponent, View_EmailListIndexComponent_Host_0, {}, {}, []);
export { EmailListIndexComponentNgFactory as EmailListIndexComponentNgFactory };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/email/email-list-index/email-list-index.component.ngfactory.js.pre-build-optimizer.js